/*
 * PAGE LAYOUT PATTERN
 *
 * Provides the shared full-height page column and compact 8px header-to-body rhythm.
 * The application shell owns outer padding; this pattern intentionally adds no inset.
 */

import { forwardRef, type HTMLAttributes } from 'react';
import { cx } from '../primitives/utils';

type PageLayoutProps = HTMLAttributes<HTMLDivElement>;

const PageLayout = forwardRef<HTMLDivElement, PageLayoutProps>(function PageLayout(
  { className, ...props },
  ref
) {
  return (
    <div
      ref={ref}
      data-page-layout="true"
      className={cx('flex h-full min-h-0 flex-col gap-2', className)}
      {...props}
    />
  );
});

export default PageLayout;
export type { PageLayoutProps };
